import { useMemo, useEffect, useState, use } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
//import dataTableDataRows from "./data/dataTableData";
import MDButton from "components/MDButton";
import { Alert, Button, Checkbox, Icon, IconButton, Tab, Tabs } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import LHHCApiService from "app/services/LHHCApiService";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import TopNavBar from "app/layout/TopNavBar";
import Grid from "@mui/material/Grid";
import moment from 'moment';
import { Box, minWidth } from "@mui/system";
import AccountSubscriptionsTable from "app/account";
import MobileMenuIconGrid from "app/layout/MobileMenuIcon";
import SubscriptionService from "app/services/SubscriptionServices";

function Horoscope({ }) {
    const subscriptionService = SubscriptionService();
    
    const isMobile = useMediaQuery('(max-width:600px)');
    const { t } = useTranslation();
    const apiService = LHHCApiService();
    const [horoscopeData, setHoroscopeData] = useState([]);
    const [filteredHoroscopeData, setFilteredHoroscopeData] = useState([]);
    const mobileColumns = [
        {
            Header: "-", accessor: "fileType", width: "25%", sortable: false,
            Cell: ({ cell }) =>
                <MDTypography
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="link"
                    color="success"
                    fontWeight="medium"
                    textGradient
                ><Icon>edit</Icon></MDTypography>
        },
        // { Header: "description", accessor: "description" },
        {
            Header: "description", accessor: "description",
            Cell: ({ cell }) => <>{cell.row.original.name} <br /> {cell.row.original.description}</>
        },
    ];
    const desktopColumns = [
        {
            Header: "action", accessor: "fileType", width: "8%", sortable: false,
            Cell: ({ cell }) =>

                <MDTypography
                    component={Link}
                    to={`/my-files/${cell.row.original.fileType == 2 ? "match/" : ""}view/${cell.row.original.id}`}
                    variant="button"
                    color="success"
                    fontWeight="medium"
                    textGradient
                ><Icon style={{ paddingTop: 4 }}>edit</Icon>&nbsp;Open</MDTypography>
        },
        {
            Header: "Created", accessor: "createdOn", width: "12%",
            Cell: ({ cell }) => moment(new Date(cell.row.original.createdOn)).format('DD/MM/YY HH:mm')
        },
        { Header: "name", accessor: "name", width: "12%" },
        { Header: "description", accessor: "description" },
    ];
    const columns = isMobile ? mobileColumns : desktopColumns;

    const fetchData = async () => {
            try {
                await subscriptionService.getSubscriptions();
            } catch (err) {
                console.log(err);
            }
        };
        useEffect(() => {
    
            fetchData();
        }, []);

    useEffect(() => {
        const fetchData = async () => {

            try {
                const data = await apiService.list();
                setHoroscopeData(data);
                console.log(data);
            } catch (err) {
                console.log(err);
            } finally {
                // setLoading(false);
            }
        };
        fetchData();
    }, []);

    const [showHC, setShowHC] = useState(true);
    const [showMatches, setShowMatches] = useState(true);
    const [showBanner, setShowBanner] = useState(() => !sessionStorage.getItem("kp_banner_dismissed"));

    const handleDismissBanner = () => {
        sessionStorage.setItem("kp_banner_dismissed", "true");
        setShowBanner(false);
    };

    useEffect(() => {
        console.log("Filtering data with showHC:", showHC, "showMatches:", showMatches);
        let filteredData;
        if ((showHC && showMatches) || (!showHC && !showMatches)) {
            // Show all records if both are true or both are false
            filteredData = horoscopeData;
        } else if (showHC) {
            // Show only fileType = 1
            console.log("Filtering for fileType = 1", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 1);
        } else if (showMatches) {
            // Show only fileType = 2
            console.log("Filtering for fileType = 2", horoscopeData[0].fileType);
            filteredData = horoscopeData.filter(item => item.fileType == 2);
        } else {
            filteredData = [];
        }
        setFilteredHoroscopeData(filteredData);
        console.log("Filtered Data: ", filteredData.length);
    }, [showHC, showMatches, horoscopeData]);

    return (
        <DashboardLayout>
            <TopNavBar />
            {showBanner && (
                <MDBox pt={1} px={0}>
                    <Alert
                        severity="info"
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={handleDismissBanner}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ borderRadius: 2 }}
                    >
                        <strong>New Feature!&nbsp; KP: ක්‍රිෂ්ණමූර්ති පද්ධති ක්‍රමය අතුලත් කර ඇත. </strong><br />
                    </Alert>
                </MDBox>
            )}
            <MDBox pt={1} pb={1}>
                <MDBox mb={1}>
                    <Card>
                        <MDBox p={3} lineHeight={1} mb={0}>
                            <Grid container spacing={2} alignItems="center">
                                
                                <Grid item xs={12}>
                                    <MDBox display="flex" justifyContent="flex-start" gap={2}>
                                        {/* Horoscope Tile */}
                                        <MDBox
                                            component={Link}
                                            to={`/my-files/horoscope/new`}
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                px: 3,
                                                py: 0,
                                                borderRadius: 3,
                                                border: `2px solid`,
                                                borderColor: 'info.main',
                                                color: 'info.main',
                                                textDecoration: 'none',
                                                transition: 'box-shadow 0.2s',
                                                boxShadow: 1,
                                                '&:hover': {
                                                    boxShadow: 4,
                                                    backgroundColor: 'info.lighter',
                                                },
                                            }}
                                        >
                                            <MDTypography
                                                variant="button"
                                                color="info"
                                                fontWeight="medium"
                                                textGradient
                                                sx={{ color: 'info.main' }}
                                            >
                                                {t("HC.HC_NEW")}
                                            </MDTypography>
                                        </MDBox>
                                        {/* Match Tile */}
                                        <MDBox
                                            component={Link}
                                            to={`/my-files/match/new`}
                                            sx={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                px: 3,
                                                py: 0,
                                                borderRadius: 3,
                                                border: `2px solid`,
                                                borderColor: 'warning.main',
                                                color: 'warning.main',
                                                textDecoration: 'none',
                                                transition: 'box-shadow 0.2s',
                                                boxShadow: 1,
                                                '&:hover': {
                                                    boxShadow: 4,
                                                    backgroundColor: 'warning.lighter',
                                                },
                                            }}
                                        >
                                            <MDTypography
                                                variant="button"
                                                color="warning"
                                                fontWeight="medium"
                                                textGradient
                                                sx={{ color: 'warning.main' }}
                                            >
                                                {t("HC.HC_NEW_MATCH")}
                                            </MDTypography>
                                        </MDBox>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ width: '100%' }}>
                                    <MDTypography fontWeight="medium" sx={{ width: '100%' }}>
                                        {t("HC.MY_PREVOUS_WORK")}
                                    </MDTypography>
                                </Grid>
                                <Grid item xs={12} mt={2}>
                                    <MDBox display="flex" alignItems="center" gap={2}>
                                        <MDTypography>
                                            <Checkbox checked={showHC} onChange={(e) => setShowHC(e.target.checked)} id="showHC" />
                                            <label htmlFor="showHC">{t("HC.SHOW_HC")}</label>
                                        </MDTypography>
                                        <MDTypography>
                                            <Checkbox checked={showMatches} onChange={(e) => setShowMatches(e.target.checked)} id="showMatches" />
                                            <label htmlFor="showMatches">{t("HC.SHOW_MATCH")}</label>
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                        <DataTable table={{
                            columns: columns,
                            rows: filteredHoroscopeData
                        }} canSearch />
                    </Card>
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
};

Horoscope.propTypes = {
    tableData: PropTypes.array,
    cell: PropTypes.shape({
        row: PropTypes.shape({
            original: PropTypes.shape({
                fileType: PropTypes.string.isRequired,
                id: PropTypes.string.isRequired,
                createdOn: PropTypes.string.isRequired,
                name: PropTypes.string, // Add validation for name
                description: PropTypes.string, // Add validation for description
            }).isRequired,
        }).isRequired,
    }),
};

export default Horoscope;